import useStore from '../store/store';

export default function useAppVersion() {
    const ver = useStore((state) => state.ver);

    return {
        ver,
        is: (v) => ver === Number(v),
        isAtLeast: (v) => ver >= Number(v),
        isAtMost: (v) => ver <= Number(v),
    };
}
